import State from './State';

const initialState: State = {
    customers: []
};

export default initialState;



// WEBPACK FOOTER //
// ./src/application/admin/initialState.ts